@if (tripsChartData$ | async; as chartData) {
  <div class="chart-wrapper">
    @if (chartData.get(chartType.TripsDistribution); as tripsDistribution) {
      <div class="chart-wrapper__chart">
        <div
          echarts
          class="chart-wrapper__chart--content"
          [options]="tripsDistribution"></div>
      </div>
    }
    <app-statistics-total
      [totalData]="chartData.get(chartType.TripsTotal)"
      [titleKey]="chartTitle[chartType.TripsTotal]">
    </app-statistics-total>
  </div>
}
